module.exports = __webpack_public_path__ + "static/media/sigma.764761b0.svg";